import classNames from 'classnames';
import React from 'react';

export interface ModalHeaderProps extends React.HTMLAttributes<HTMLElement> {
  tag?: React.ElementType;
  wrapTag?: React.ElementType;
  toggle?: (e?: React.MouseEvent) => void;
  closeAriaLabel?: string;
  charCode?: string | number;
  close?: React.ReactNode;
  [key: string]: any;
}

const ModalHeader = ({
  className,
  children,
  toggle,
  tag: Tag = 'h5',
  wrapTag: WrapTag = 'div',
  closeAriaLabel = 'Close',
  charCode = 215,
  close,
  ...attributes
}: ModalHeaderProps) => {
  let closeButton: React.ReactNode = null;
  if (!close && toggle) {
    const closeIcon = typeof charCode === 'number' ? String.fromCharCode(charCode) : charCode;
    closeButton = (
      <button type="button" onClick={toggle} className="close" aria-label={closeAriaLabel}>
        <span aria-hidden="true">{closeIcon}</span>
      </button>
    );
  }

  return (
    <WrapTag {...attributes} className={classNames(className, 'modal-header')}>
      <Tag className="modal-title">{children}</Tag>
      {close || closeButton}
    </WrapTag>
  );
};

export default ModalHeader;
